<template>
  <section class="main-wrapper carousel d-none d-md-block">
    <div class="banner-wrapper" id="mySwipe" style="position:relative;z-index:120;">
    <swiper
        :modules="modules"
        navigation
        :pagination="{ clickable: true }"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        effect="slide"
        :autoplay='{"delay": 5000}'
    >
      <swiper-slide v-for="item in carousels" :key="item.id" :loop="true">
        <img :src="base_url+item.img_url.url" style="width: 100%;max-height: 41rem;">
      </swiper-slide>
    </swiper>
    </div>
  </section>
</template>
<script>

import 'swiper/swiper-bundle.min.css'
import { Navigation, Pagination, Autoplay,Scrollbar } from "swiper"
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue.js"

import {getCarousels} from "@/api/home"

export default {
  components:{Swiper,SwiperSlide},
  setup() {
    const onSwiper = () => {
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Autoplay,Scrollbar],
    }
  },
  data() {
    return {
      base_url:process.env.VUE_APP_BASE_API,
      carousels: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      const temp = {nav: 1}
      getCarousels(temp).then((response) => {
        this.carousels = response
      })
    }
  },
}
</script>